import { createSlice } from "@reduxjs/toolkit";
import { fetchUserDetails, fetchLatestPermissions, sendForgotPasswordOTP, verifyOTPAndResetPassword } from './thunk';
import { LoginState, User } from "./types";

// export const initialState = {
//   user: {},
//   error: "",
//   loading: false,
//   isUserLogout: false,
//   errorMsg: false,
// };
const initialState = {
  user: null as User | null,
  error: null as string | null,
  loading: false,
  isUserLogout: false,
  errorMsg: false,
  forgotPassword: {
    loading: false,
    error: null as string | null,
    otpSent: false,
    cooldown: 0,
    timeActive: false,
  },
} as LoginState;

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      // state.error = action.payload.data;
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      console.log("login success");
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
      // console.log(
      //   `state: ${JSON.stringify(state)} , action: ${JSON.stringify(action)}`
      // );
      // console.log("state.user", state.user);
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
    reset_login_flag(state) {
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
    },
    // Forgot Password Actions
    forgotPasswordLoading(state, action) {
      (state as any).forgotPassword.loading = action.payload;
    },
    forgotPasswordError(state, action) {
      (state as any).forgotPassword.error = action.payload;
      (state as any).forgotPassword.loading = false;
    },
    otpSentSuccess(state) {
      (state as any).forgotPassword.otpSent = true;
      (state as any).forgotPassword.cooldown = 300; // 5 minutes
      (state as any).forgotPassword.timeActive = true;
      (state as any).forgotPassword.loading = false;
      (state as any).forgotPassword.error = null;
    },
    updateCooldown(state, action) {
      (state as any).forgotPassword.cooldown = action.payload;
      if (action.payload <= 0) {
        (state as any).forgotPassword.timeActive = false;
      }
    },
    resetForgotPassword(state) {
      (state as any).forgotPassword = {
        loading: false,
        error: null,
        otpSent: false,
        cooldown: 0,
        timeActive: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.user = action.payload;
      })
      .addCase(fetchLatestPermissions.fulfilled, (state, action) => {
        if (state.user) {
          state.user.permissions = action.payload;
        }
      })
      .addCase(sendForgotPasswordOTP.pending, (state) => {
        (state as any).forgotPassword.loading = true;
        (state as any).forgotPassword.error = null;
      })
      .addCase(sendForgotPasswordOTP.fulfilled, (state) => {
        (state as any).forgotPassword.loading = false;
        (state as any).forgotPassword.error = null;
      })
      .addCase(sendForgotPasswordOTP.rejected, (state, action) => {
        (state as any).forgotPassword.loading = false;
        (state as any).forgotPassword.error = action.payload as string || "Failed to send OTP";
      })
      .addCase(verifyOTPAndResetPassword.pending, (state) => {
        (state as any).forgotPassword.loading = true;
        (state as any).forgotPassword.error = null;
      })
      .addCase(verifyOTPAndResetPassword.fulfilled, (state) => {
        (state as any).forgotPassword.loading = false;
        (state as any).forgotPassword.error = null;
      })
      .addCase(verifyOTPAndResetPassword.rejected, (state, action) => {
        (state as any).forgotPassword.loading = false;
        (state as any).forgotPassword.error = action.payload as string || "Failed to reset password";
      });
  },
});


export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  forgotPasswordLoading,
  forgotPasswordError,
  otpSentSuccess,
  updateCooldown,
  resetForgotPassword,
} = loginSlice.actions;

export default loginSlice.reducer;
